/**
 * BITZ Club International — Single source of truth for public contact details.
 *
 * Update the number HERE and every public WhatsApp / call / tel link across the
 * site updates automatically. This file replaces ~6 duplicated hardcoded values
 * that previously existed in HomePage / LandingPage / ContactPage / BrochurePage /
 * MembershipPage / WhatsAppFloat / MarketingLanding.
 *
 * Format rules:
 *  - BITZ_WHATSAPP_DISPLAY  → human-readable for visible text
 *  - BITZ_WHATSAPP_RAW      → digits-only with country code, used in wa.me URLs
 *  - BITZ_TEL_RAW           → digits-only with country code, used in tel: links
 *
 *  All three MUST stay in sync. Country code 91 (India) included in RAW versions.
 */

export const BITZ_WHATSAPP_DISPLAY = '+91 78129 01118';
export const BITZ_WHATSAPP_RAW = '917812901118';
export const BITZ_TEL_RAW = '917812901118';
export const BITZ_EMAIL = 'info@thebitsclub.com';

/**
 * Build a WhatsApp deep-link URL with an optional prefilled message.
 * Returns: https://wa.me/917812901118?text=...
 */
export const waLink = (message) => {
  const base = `https://wa.me/${BITZ_WHATSAPP_RAW}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
};

/**
 * tel: link for click-to-call buttons.
 */
export const telLink = () => `tel:+${BITZ_TEL_RAW}`;
